<div class="slider-container">
  <app-slider-navigation class="navigation" (direction)="navigate($event)"></app-slider-navigation>
  <swiper-container #swiperRef class="swiper-slide slides primary-bullets banner-slides" autoplay="true">
    <swiper-slide *ngFor="let banner of banners">
      <app-banner class="banner" [banner]="banner" [style]="bannerStyle" [type]="bannerType"
        [loading]="loading"></app-banner>
    </swiper-slide>
  </swiper-container>
</div>